import type { Template } from '@ztechapps/common.contract'

// The unfiltered pivot sentinel — distinct from a selector's own "no filter template" placeholder.
export const showAllFilterTemplate = { _id: '_show_all_', name: 'Show All', value: '{}' } as unknown as Template
